import { React, useState } from "react";
import Layout from "../../components/Layout/Layout";

import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles/AuthStyles.css";
import { useAuth } from "../../context/auth.js";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const [auth, setAuth] = useAuth();
  const Location = useLocation();

  const handleSumbit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`/api/v1/auth/login`, { email, password });
      debugger;
      if (res && res.data.success) {
        toast.success(res.data.message);
        setTimeout(() => {
          setAuth({
            ...auth,
            user: res.data.user,
            token: res.data.token,
          });
          localStorage.setItem("auth", JSON.stringify(res.data));
          navigate(Location.state || "/");
        }, 1000);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };
  return (
    <Layout title={"Register Page"}>
      <div className="form-container">
        <h1> User Login</h1>
        <form onSubmit={handleSumbit}>
          <div className="mb-3">
            <input
              type="email"
              placeholder="Your Email"
              className="form-control"
              id="exampleInputEmail"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              required
            />
          </div>

          <div className="mb-3">
            <input
              type="password"
              placeholder="Your Password"
              className="form-control"
              id="exampleInputPassword1"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <button type="submit" className="btn btn-primary">
              Login
            </button>
          </div>

          <div className="mb-3  ">
            <button
              type="button"
              className="btn btn-danger forgotbutton "
              onClick={() => {
                navigate("/forgot-password");
              }}
            >
              Forgot Password
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default Login;
